import { ArchivedEventsPage } from "./ArchivedEventsPage";

export default ArchivedEventsPage;